module.exports = __webpack_public_path__ + "img/print_radio_checked.43efe634.svg";